import {organisations} from "./organisations"

export const childOrganisations: TableModule = {
    ...organisations,
    name: "childOrganisations",
    route: "spa.settings.childOrganisations",
    columns: [
        {
            name: "member_id",
            sortable: true,
            width: "w-[160px]",
            breakpoint: "xl"
        }, {
            name: "name",
            pageLink: true,
            sortable: true,
            sortBy: "name",
            mobile: true
        }, {
            name: "city",
            sortable: true,
            breakpoint: "xl",
            width: "w-1/12"
        }, {
            name: "type",
            sortable: true,
            breakpoint: "xl"
        }, {
            name: "active",
            width: "w-[60px]",
            breakpoint: "lg"
        }, {
            name: "categories",
        }, {
            name: "last_active_at",
            width: "w-[150px]"
        }
    ],
    filters: [],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "organisations"]
        }
    ]
}

